import { render, staticRenderFns } from "./IgIcon.vue?vue&type=template&id=43dfeefa&scoped=true&lang=pug&"
import script from "./IgIcon.vue?vue&type=script&lang=ts&"
export * from "./IgIcon.vue?vue&type=script&lang=ts&"
import style0 from "./IgIcon.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./IgIcon.vue?vue&type=style&index=1&id=43dfeefa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43dfeefa",
  null
  
)

component.options.__file = "IgIcon.vue"
export default component.exports